// extracted by mini-css-extract-plugin
module.exports = {"Container":"drawer-body_Container__MBUsL"};